import isImageProxyEnabled from './isImageProxyEnabled';
import isProxyImage from './isProxyImage';
import loadFromModelDProxy from './loadFromModelDProxy';
import loadFromModelBProxy from './loadFromModelBProxy';
import { ImageProxyEndpoint } from './createImageProxyDatapoint';
import { isFeatureEnabled } from 'owa-feature-flags';

let proxyCount = 0;
let logEvery = 10;

function getTelemetryConfig() {
    const config = {
        proxyCount,
        logEvery,
    };
    proxyCount++;
    return config;
}

/**
 * Call the proper ImageProxy endpoint
 * @param img The image tag into which to load the proxied image
 * @param endpointToCall the endpoint that should be called
 * @param isShadowTraffic whether to call as shadowTraffic
 */
export async function callProxy(
    img: HTMLImageElement,
    endpointToCall: ImageProxyEndpoint,
    isShadowTraffic: boolean = false,
    getTelemetryConfigFn: typeof getTelemetryConfig = getTelemetryConfig
) {
    if (
        endpointToCall == ImageProxyEndpoint.ModelD ||
        endpointToCall == ImageProxyEndpoint.Cosmic
    ) {
        return loadFromModelDProxy(endpointToCall, img, isShadowTraffic, getTelemetryConfigFn());
    } else {
        return loadFromModelBProxy(img, isShadowTraffic, getTelemetryConfigFn());
    }
}

/**
 * Load an image from proxy
 * @param img The image
 */
export default async function loadFromProxy(
    img: HTMLImageElement,
    callProxyFn: typeof callProxy = callProxy
) {
    // Return false if it is not a proxy capable image
    // so that it can be handled by next handler in the chain
    if (!isProxyImage(img)) {
        return false;
    }

    if (isImageProxyEnabled()) {
        const primaryEndpoint =
            isFeatureEnabled('rp-imageProxyOnCosmic') ||
            isFeatureEnabled('rp-imageProxyOnCosmic-test')
                ? ImageProxyEndpoint.Cosmic
                : isFeatureEnabled('rp-imageProxyOnModelD')
                ? ImageProxyEndpoint.ModelD
                : ImageProxyEndpoint.ModelB;

        const secondaryEndpoints = [
            ...(isFeatureEnabled('rp-imageProxyOnModelBShadowing')
                ? [ImageProxyEndpoint.ModelB]
                : []),
            ...(isFeatureEnabled('rp-imageProxyOnModelDShadowing')
                ? [ImageProxyEndpoint.ModelD]
                : []),
            ...(isFeatureEnabled('rp-imageProxyOnCosmicShadowing')
                ? [ImageProxyEndpoint.Cosmic]
                : []),
        ].filter(ep => ep !== primaryEndpoint);

        await callProxyFn(img, primaryEndpoint);

        for (const endpointToCall of secondaryEndpoints) {
            callProxyFn(img, endpointToCall, true);
        }
    } else {
        //Block the image when External Images setting is disabled.
        img.src = '';
    }

    return true;
}
